.cr{outline:none;}